import React, { useEffect } from "react";
import "../../Informations/Information.css";
import nillimg from "../../../Assets/nillimg.jpeg";
import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
const AboutUsComponent = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <div className="page-main-container-aboutus">
        <div className="business-price-numbs">
          <div className="nill-img-text-hone">
            {/* <div className='nill-img-aboutus'>
                            <img src={nillimg} alt="" />
                        </div> */}
            <div className="aboutus-head-padd">
              <h2 className="htwo-heading-aboutus">About NIL-Collab</h2>
              <p className="text-aboutus">
                NIL-Collab is a dynamic marketplace connecting fans, brands, and
                athletes. The platform harnesses cutting-edge technology to
                create a space where every participant benefits. Fans connect
                directly with athletes and enjoy personalized experiences,
                brands expand their reach and drive measurable growth through
                authentic influence, and athletes unlock sponsorships,
                partnerships, and revenue opportunities.
              </p>
              <p className="text-aboutus">
                NIL-Collab transforms the way fans interact with athletes,
                brands grow their reach, and athletes maximize their potential.
                The platform is designed to create meaningful connections that
                drive engagement, growth, and tangible results.{" "}
              </p>
            </div>
          </div>
          <div className="program-benefits-aboutus">
            <h2>How NIL-Collab Creates Value:</h2>
            <h3>Starting Your Fan Experience with Athletes</h3>
            <p className="text-aboutus">
              Fans and supporters gain unique opportunities to engage with their
              favorite athletes through personalized interactions, exclusive
              content, and behind-the-scenes experiences. Partnering with
              athletes helps fans grow their social presence, connect with a
              wider and more loyal audience, and enjoy meaningful access to the
              people they admire. Every interaction creates a closer connection
              and adds value to the fan experience.
            </p>
            <h3>Starting Your Brand Partnership with Athletes</h3>
            <p className="text-aboutus">
              Brands can expand their reach and drive measurable growth by
              partnering with athletes whose social followings reach hundreds of
              thousands or even millions. These athletes bring authentic
              influence, credibility, lifestyle impact, and visibility that
              elevate brand presence. Partnerships deliver real results, from
              increasing engagement and conversions to boosting revenue, making
              athlete collaborations a powerful way to grow and strengthen a
              brand.
            </p>
            <h3>
              {" "}
              Building Your NIL Profile as an Athlete to Connect with Brands,
              Fans, and Supporters
            </h3>
            <p className="text-aboutus">
              Athletes can maximize their influence and unlock new opportunities
              by building an NIL profile. Creating a profile opens doors to
              sponsorships, contributions, and brand partnerships that align
              with their goals, image, and lifestyle. Thousands of athletes are
              already using the platform to grow their presence, gain
              recognition, and turn social influence into real results. Every
              profile helps athletes showcase their talent, connect with
              supporters, and access opportunities that extend far beyond the
              playing field.
            </p>
            {/* <h3> 4. Equalizing NIL Access</h3>
            <p className="text-aboutus">
              NIL-Collab could help bridge the gap between wealthier programs
              with large fanbases and smaller schools where NIL opportunities
              might be more limited. If local communities can come together to
              support athletes, the system could become less reliant on
              big-money deals and more focused on equal opportunity. This will
              help ensure that athletes from all backgrounds have access to the
              resources they need.
            </p>
            <h3> 5. Transparency and Trust</h3>
            <p className="text-aboutus">
              If a system like NIL-Collab is built with transparency, athletes,
              schools, and contributor will have a clear understanding of how
              funds are distributed and how deals are structured. Ensuring that
              everyone involved understands the terms and goals of the
              initiative will build trust, which is critical to maintaining
              long-term support from contributors and the athletes themselves.
            </p>
            <h3> 6. Boosting Athlete Branding</h3>
            <p className="text-aboutus">
              Rather than simply being passive recipients of deals, athletes
              could actively participate in the community-building aspect, using
              their personal brands to promote local businesses or initiatives.
              This will provide a win-win situation: athletes enhance their
              personal brand while helping the community thrive, leading to more
              collaborative opportunities down the line.
            </p> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default AboutUsComponent;



// import React, { useEffect } from 'react'
// import "../../Informations/Information.css"
// import nillimg from "../../../Assets/nillimg.jpeg"
// import Footer from '../../Footer/Footer'
// import Header from '../../Header/Header'
// const AboutUsComponent = () => {
//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);
//     return (
//         <>
//             <Header />
//             <div className='page-main-container-aboutus'>
//                 <div className='business-price-numbs'>
//                     <div className='nill-img-text-hone'>
//                         <div className='nill-img-aboutus'>
//                             <img src={nillimg} alt="" />
//                         </div>
//                         <div>
//                             <h2 className='htwo-heading-aboutus' >About NIL-Collab</h2>
//                             <p className='text-aboutus'>
//                                 NIL-Collab is beneficial in how athletes approach NIL and how local communities engage with college sports. The NIL-Collab platform enables athletes from small or large programs to receive the same opportunity to receive contributions while offering transparency throughout the process. This will serve an instrumental role in leveling the playing field while fostering collaboration and long-term relationships between athletes and supporters.
//                             </p>
//                             <p className='text-aboutus'>
//                                 NIL-Collab creates a more supportive and sustainable environment for athletes to maximize their earning potential. By working with schools, collectives, and local businesses, as well as involving alumni and fans, it could help level the playing field and ensure that athletes from all programs have access to NIL opportunities, not just those at high-profile schools.
//                             </p>
//                         </div>
//                     </div>
//                     <div className='program-benefits-aboutus'>
//                         <h2>Program Benefits:</h2>
//                         <h3> 1. Collective Efforts for Broader Reach</h3>
//                         <p className='text-aboutus'>
//                             Rather than relying solely on individual endorsement deals, NIL-Collab will enable athletes to pool resources from multiple sources, creating a system where the combined efforts of local businesses, alumni, and fans contribute to athletes' overall earning potential. This would allow athletes, even those from smaller schools, to gain some of the financial benefits that star athletes at big programs receive.
//                         </p>
//                         <h3>2. Building Stronger Community Ties</h3>
//                         <p className='text-aboutus'>
//                             By engaging local businesses and alumni, this model will foster a closer connection between the athletic programs and the community. Fans and supporters of college teams could directly contribute to the success of their athletes, potentially creating a stronger sense of connection and loyalty. It could also increase local business visibility by aligning them with popular athletes and college sports teams.
//                         </p>
//                         <h3> 3. Creating a Sustainable Ecosystem</h3>
//                         <p className='text-aboutus'>
//                             The involvement of alumni and fans in NIL initiatives will provide long-term sustainability. Contributions could help establish a fund that athletes can tap into over multiple years, reducing the one-off nature of NIL deals and providing consistent support throughout their college careers. This would help athletes balance the pressures of academics, athletics, and managing their personal brand while still benefiting financially.
//                         </p>
//                         <h3>  4. Equalizing NIL Access</h3>
//                         <p className='text-aboutus'>
//                             NIL-Collab could help bridge the gap between wealthier programs with large fanbases and smaller schools where NIL opportunities might be more limited. If local communities can come together to support athletes, the system could become less reliant on big-money deals and more focused on equal opportunity. This will help ensure that athletes from all backgrounds have access to the resources they need.
//                         </p>
//                         <h3> 5. Transparency and Trust</h3>
//                         <p className='text-aboutus'>
//                             If a system like NIL-Collab is built with transparency, athletes, schools, and contributor will have a clear understanding of how funds are distributed and how deals are structured. Ensuring that everyone involved understands the terms and goals of the initiative will build trust, which is critical to maintaining long-term support from contributors and the athletes themselves.
//                         </p>
//                         <h3>  6. Boosting Athlete Branding</h3>
//                         <p className='text-aboutus'>
//                             Rather than simply being passive recipients of deals, athletes could actively participate in the community-building aspect, using their personal brands to promote local businesses or initiatives. This will provide a win-win situation: athletes enhance their personal brand while helping the community thrive, leading to more collaborative opportunities down the line.
//                         </p>
//                     </div>
//                 </div>
//             </div>
//             <Footer />
//         </>
//     )
// }
// export default AboutUsComponent